import { useTranslation } from 'react-i18next';
import { TFunction } from 'i18next';
import { FormikHelpers } from 'formik';
import { ErrorInfo } from '../types/interfaces';
import { dialogIndicatorContextGlobal } from '../utils/helpers/dialogIndicatorContext';
import { showToast } from '../components/Toast/showToast';

const setErrorFromArray = (
  errorInfo: ErrorInfo[],
  setFieldError: (field: string, message: string) => void,
  t: TFunction
) => {
  let isErrorToastShown = false;
  errorInfo.forEach((error) => {
    const errorMessage = t(error.message);

    if (error.field) {
      if (Array.isArray(error.field)) {
        const fields = error.field;
        for (const field of fields) {
          setFieldError(field, errorMessage);
        }
      } else {
        setFieldError(error.field, errorMessage);
      }
    } else if (!isErrorToastShown) {
      isErrorToastShown = true;
      showToast(errorMessage || 'general-error');
    }
  });
};

const useErrorCb = () => {
  const { t } = useTranslation();
  function setFormikHelpers<T = object>(
    setFieldError: FormikHelpers<T>['setFieldError'],
    setSubmitting: FormikHelpers<T>['setSubmitting']
  ) {
    const modal = document.querySelectorAll('[data-role="dialog-hub"]');

    return (errorInfo: ErrorInfo | ErrorInfo[]) => {
      if (errorInfo) {
        if (Array.isArray(errorInfo)) {
          setErrorFromArray(errorInfo, setFieldError, t);
        } else {
          const errorMessage = t(errorInfo.message) ? t(errorInfo.message) : t('generalError');

          if (errorInfo.field) {
            if (Array.isArray(errorInfo.field)) {
              const fields = errorInfo.field;
              for (const field of fields) {
                setFieldError(field, errorMessage);
              }
            } else {
              setFieldError(errorInfo.field, errorMessage);
            }
          } else if (modal.length > 0) {
            dialogIndicatorContextGlobal.setIndicator?.({
              text: errorMessage,
              type: 'warning'
            });
          } else {
            showToast(errorMessage);
          }
        }
      }

      setSubmitting(false);
    };
  }

  return setFormikHelpers;
};

export default useErrorCb;
